import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Attendance } from "../../shared/data.service";
import { UpdateAttendanceRequest } from "../../shared/UpdateAttendanceRequest";
import { AttendanceCheckRequest } from "../../shared/AttendanceCheckRequest";
import * as moment from "moment";

@Component({
	selector: "app-student-edit-attendance",
	templateUrl: "./student-edit-attendance.component.html",
	styleUrls: ["./student-edit-attendance.component.css"],
})
export class StudentEditAttendanceComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private AttendanceTempService: DataService_Attendance
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.SelectedAttendance = this.dialogConfig.data.SelectedAttendance;

		console.log(this.dialogConfig.data);

		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.StudentName = this.SelectedPerson.FirstName + " " + this.SelectedPerson.LastName;

		this.EntryDate = new Date(this.SelectedAttendance.EntryDT);
		this.EntryTime = new Date(this.SelectedAttendance.EntryDT);

		this.Comments = String(this.SelectedAttendance.c_comment);
		this.OriginalComments = String(this.SelectedAttendance.c_comment);

		//INSERT LOAD COMBO BOX DATA
		this.LoadStudentID();
		this.LoadStatusList();
		// this.LoadExcuses(); // Load after status
		// this.LoadSuspended(); // Only Load before adding
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	errorMessage: any = "";

	//Data from parent
	SelectedAttendance: any; //Edit
	user: any;
	SchoolID: any;
	SelectedPerson: any;
	StudentID: any = "";
	StudentName: any = "";
	Supsended: any = 0;
	ReleaseScheduleID: any = 0;

	//INSERT FORM DATA
	EntryDate: Date = new Date();
	EntryTime: Date = new Date();

	StatusID: any = 0;
	lstAttendanceStatus: any = [];

	DefaultAbsentReason: number = -1;
	DefaultTardyReason: number = -1;
	Excuse: any;
	lstExcuse: any = [];

	Comments: any = "";
	OriginalComments: any = "";

	LoadingStudentID: boolean = true;
	LoadingExcuses: boolean = true;
	LoadingStatus: boolean = true;
	Processing: boolean = false;

	///////////////////////////////////////

	///////////////////////////////////////
	// Load Data
	///////////////////////////////////////
	LoadSuspended() {
		//ONLY WHEN ADDING (Don't need to call SP when date changes or on init)
		var result = this.AttendanceTempService.CheckSuspended(this.SelectedPerson.PersonID, moment(this.EntryDate).format("MM/DD/YYYY"));
		result.subscribe(
			(response) => {
				this.Supsended = response;

				//ERROR, can't use suspended excuse
				//unless student is actually suspended on
				//that date
				if (this.Supsended == 0 && this.Excuse.ExcuseID == 26) {
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Can't use suspension excuse if student is not suspended",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.Processing = false;
							return;
						},
					});
				}
				// else if(this.Supsended == 1){
				//   this.confirmationService.confirm(
				//     {
				//       key: "add",
				//       acceptLabel: "Remove Suspension",
				//       rejectLabel: "Keep Suspension",
				//       rejectVisible: true,
				//       message: "You are entering attendance for a student that is suspended. Do you want to or remove the suspension or keep the student suspended?",
				//       header: "Student Suspended",
				//       icon: "fa",
				//       accept: () => {
				//         this.Supsended = 0;
				//         this.LoadReleaseSchedule();
				//       },
				//       reject: () =>{
				//         this.LoadReleaseSchedule();
				//       }
				//   });
				// }
				else {
					//Finish (OR LOAD RELEASE SCHEDULE)
					this.LoadReleaseSchedule();
				}
			},
			(error) => {}
		);
	}

	LoadReleaseSchedule() {
		//ONLY WHEN ADDING (Don't need to call SP when date changes or on init)
		var result = this.AttendanceTempService.PersonGetReleaseSchedule(this.SelectedPerson.PersonID, moment(this.EntryDate).format("MM/DD/YYYY"));
		result.subscribe(
			(response) => {
				this.ReleaseScheduleID = response;

				//Finish (OR LOAD RELEASE SCHEDULE)
				this.DateCheck();
			},
			(error) => {}
		);
	}

	DateCheck() {
		var parms: AttendanceCheckRequest = {
			PersonID: this.SelectedPerson.PersonID,
			EntryDate: moment(this.EntryDate).format("MM/DD/YYYY"),
		};

		var result = this.AttendanceTempService.AttendanceModifyCheck(parms);
		result.subscribe(
			(response: any) => {
				var NotToday = response.NotToday;
				var IsWeekend = response.IsWeekend;
				var SchoolClosed = response.SchoolClosed;

				//No Date Warnings
				if (NotToday == false && IsWeekend == false && SchoolClosed == false) {
					//Finish
					this.FinishUpdate();
				} else {
					var WarningMessage: string = "WARNING: ";

					if (NotToday == true) {
						WarningMessage += "You are modifying an attendance record that did not happen today. ";
					}
					if (IsWeekend == true) {
						WarningMessage += "You are entering an attendance record that happens on a weekend. ";
					}
					if (SchoolClosed == true) {
						WarningMessage += "School calendar is set to be closed on the selected date. ";
					}

					WarningMessage += "Do you want to continue?";

					this.confirmationService.confirm({
						key: "errorcheck",
						acceptLabel: "Yes",
						rejectLabel: "No",
						rejectVisible: true,
						message: WarningMessage,
						header: "Confirm Entry Date",
						icon: "fa",
						accept: () => {
							this.FinishUpdate();
						},
					});
				}
			},
			(error) => {}
		);
	}

	LoadStudentID() {
		this.LoadingStudentID = true;
		var result = this.AttendanceTempService.LoadStudentID(this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				this.StudentID = response[0];
				this.LoadingStudentID = false;
			},
			(error) => {
				this.LoadingStudentID = false;
			}
		);
	}

	LoadStatusList() {
		this.LoadingStatus = true;
		var result = this.AttendanceTempService.LoadStatusList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAttendanceStatus = response;

				this.StatusID = this.lstAttendanceStatus[0].AttendanceStatusID;

				this.StatusID = this.SelectedAttendance.AttendanceStatusID;

				this.LoadExcuses();

				this.LoadingStatus = false;
			},
			(error) => {
				this.LoadingStatus = false;
			}
		);
	}

	LoadExcuses() {
		this.LoadingExcuses = true;

		var result = this.AttendanceTempService.LoadExcuses(this.SchoolID, 1);
		result.subscribe(
			(response: any) => {
				this.DefaultAbsentReason = response.DefaultAbsentReason;
				this.DefaultTardyReason = response.DefaultTardyReason;
				this.lstExcuse = response.lstInfo;

				this.lstExcuse.unshift({
					ExcuseID: -1,
					ExcuseDesc: "<Select an Excuse>",
					IsCountAsPresent: false,
				});

				this.Excuse = this.lstExcuse[0];

				// console.log(this.SelectedAttendance);

				if (this.SelectedAttendance.ExcuseID > 0) {
					for (var z = 0; z < this.lstExcuse.length; z++) {
						var next = this.lstExcuse[z];

						if (next.ExcuseID == this.SelectedAttendance.ExcuseID) {
							this.Excuse = next;
						}
					}
				}

				this.LoadingExcuses = false;
			},
			(error) => {
				this.LoadingExcuses = false;
			}
		);
	}

	GetDefaultExcuse() {
		this.Excuse = this.lstExcuse[0];

		if ((this.StatusID == 2 && this.DefaultAbsentReason > 0) || (this.StatusID == 3 && this.DefaultTardyReason > 0)) {
			for (var z = 0; z < this.lstExcuse.length; z++) {
				var next = this.lstExcuse[z];

				if (this.StatusID == 2 && next.ExcuseID == this.DefaultAbsentReason) {
					this.Excuse = next;
					break;
				} else if (this.StatusID == 3 && next.ExcuseID == this.DefaultTardyReason) {
					this.Excuse = next;
					break;
				}
			}
		}
	}

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////

	//INSERT CUSTOM BUTTON METHODS
	onUpdateAttendance() {
		this.errorMessage = "";
		this.Processing = true;

		//Error handling
		if (this.HasExcuse() == true && this.Excuse.ExcuseID == -1) {
			this.errorMessage = "Must select an excuse";
			this.Processing = false;
			return;
		}

		this.LoadSuspended();
	}

	FinishUpdate() {
		// @PersonID  AS INT,
		// @EntryDT  AS DATETIME,
		// @AttendanceStatusID AS INT,
		// @ExcuseID  AS INT,
		// @Suspended  AS CHAR(1),
		// @EntryTypeID  AS INT,
		// @SchoolID  AS INT,
		// @ReleaseScheduleID AS INT,
		// @c_personID  AS INT,
		// @c_comment  AS VARCHAR(128) = '',
		// @ScanStation  AS VARCHAR(50) = '',

		var EntryDT = this.EntryDate;
		EntryDT.setHours(this.EntryTime.getHours(), this.EntryTime.getMinutes(), this.EntryTime.getSeconds());

		var strEntryDT = moment(EntryDT).format("MM/DD/YYYY hh:mm:ss a");

		let parms: UpdateAttendanceRequest = {
			PersonID: this.SelectedPerson.PersonID,
			EntryDT: strEntryDT,
			AttendanceStatusID: this.StatusID,
			ExcuseID: this.Excuse.ExcuseID,
			EntryTypeID: 9, //Admin Attendance (Created from this screen)
			Suspended: this.Supsended, //Load if the student is suspeneded or not
			ReleaseScheduleID: this.ReleaseScheduleID, //Load if a release is going on at the selected date?
			c_personID: this.user.personID,
			c_comment: this.Comments,
		};

		var result = this.AttendanceTempService.UpdateAttendance(parms); //
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Attendance record was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Attendance Record",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////

	///////////////////////////////////////
	// Events
	///////////////////////////////////////
	onStatusChange(val) {
		this.StatusID = val;
		this.GetDefaultExcuse();
	}
	///////////////////////////////////////

	///////////////////////////////////////
	// Helpers
	///////////////////////////////////////

	HasExcuse() {
		//Present(1) doesn't need an excuse
		return this.StatusID == 1 ? false : true;
	}

	IsLoading() {
		return this.LoadingStudentID == true || this.LoadingExcuses == true || this.LoadingStatus == true || this.Processing == true;
	}

	CommentsNotChanged() {
		return String(this.OriginalComments) == String(this.Comments);
	}

	///////////////////////////////////////
}
